// extracted by mini-css-extract-plugin
export default {"wrapper":"DuckTracker_wrapper__C63C1","duckcontainer":"DuckTracker_duckcontainer__TrFwB","description":"DuckTracker_description__TdnlV"};